<template lang="pug">
    div.ml-2.mr-2
      a.btn.btn-success(v-if="(image_mode && reserved)" :class="`disabled btn-${btn_size}`" :style="{ color: 'white' }" @click="onClick") {{btn_doing_label}}
      a.btn.btn-success(v-else :class="`btn-${btn_size}`" :style="{ color: 'white' }" @click="onClick") {{btn_label}}
      RefreshWebDesign(v-if="show_modal", @close-modal="show_modal = false" :token="token" :image_mode="image_mode")
</template>
  
  <script>
  //libs
  import RefreshWebDesign from "./modals/refresh_web_design.vue";
  
  export default {
    props: {
      btn_label: {type: String, default: "デザイン更新" },
      btn_doing_label: {type: String, default: "デザイン更新中" },
      token: {type: String, default: "" },
      btn_size: {type: String, default: "sm" },
      image_mode: {type: Boolean, default: true },
      reserved: {type: Boolean, default: false },
    },
    methods: {
      onClick(e){
          e.preventDefault()
          this.show_modal = true
          return false
      },
    },
    data(){
      return {
        show_modal: false,
      }
    },
    components: {
      RefreshWebDesign,
    },
  }
  </script>